import { Button } from '@wot/components';
import { useState } from 'react';
import { MdClose } from 'react-icons/md';
import plansApi from '../../../../api/plans';
import BottomSheet from '../../../../components/Bottomsheet';
import { LPlan } from '../../../../interfaces/Plan';

function AddClasses({ plan, setPlan, setShowPopup }: { plan: LPlan; setPlan: any, setShowPopup: any }) {
  const [noOfExtraClasses, setNoOfExtraClasses] = useState(3);

  const addComplimentaryClasses = () => {
    plansApi.updatePlan(plan._id, { totalSessions: plan.totalSessions + noOfExtraClasses }).then(() => {
      setPlan({
        ...plan,
        totatSessions: plan.totalSessions + noOfExtraClasses
      })
    })
  };

  return (
    <BottomSheet height={50}>
      <div className="w-full h-full p-5 flex flex-col items-center">
        <div className="w-full flex justify-between border-b pt-2 pb-5">
          <div />
          <h1 className="w-full mx-auto text-base md:text-xl text-center font-semibold">Add Complimentary Classes</h1>
          <MdClose className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setShowPopup(undefined)} />
        </div>
        <div className="flex flex-col items-center justify-center h-full">
          <div className="flex gap-8 items-center">
            <p className="text-lg">Add No. of Complimentary Classes</p>
            <div className="flex border-2 rounded-md text-center">
              <div
                className={`px-4 py-2 border-r-2 cursor-pointer ${noOfExtraClasses === 1 && 'bg-gray-200 text-gray-400'
                  }`}
                onClick={() => {
                  noOfExtraClasses > 1 && setNoOfExtraClasses(noOfExtraClasses - 1);
                }}
              >
                -
              </div>
              <div className="px-4 py-2">{noOfExtraClasses}</div>
              <div
                className={`px-4 py-2 border-l-2 cursor-pointer ${noOfExtraClasses === 10 && 'bg-gray-200 text-gray-400'
                  }`}
                onClick={() => {
                  noOfExtraClasses < 10 && setNoOfExtraClasses(noOfExtraClasses + 1);
                }}
              >
                +
              </div>
            </div>
          </div>
          <div className="flex gap-4 w-60 py-6">
            <Button
              block
              type="s-outlined"
              text={'Cancel'}
              onClick={() => {
                setShowPopup(false);
              }}
            />
            <Button
              block
              type="primary"
              text={'Save'}
              onClick={() => {
                addComplimentaryClasses();
                setShowPopup(false);
              }}
            />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
}

export default AddClasses;
